"use client";

import { Link } from "@/i18n/navigation";
import { ComponentProps, MouseEvent, useCallback } from "react";
import posthog from "posthog-js";

type CommonProps = {
  event: string;
  properties?: Record<string, unknown>;
};

type LinkProps = CommonProps &
  Omit<ComponentProps<typeof Link>, "onClick" | "href"> & {
    href: string;
  };

export function ToolTrackedLink({
  event,
  properties,
  href,
  onClick,
  ...rest
}: LinkProps) {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      posthog.capture(event, properties);
      onClick?.(e);
    },
    [event, properties, onClick],
  );
  return <Link {...rest} href={href} onClick={handleClick} />;
}

